export const ERROR_OLAS_LIST = 'channelmap/olas/error-olas-list';
export const RECEIVE_OLAS_LIST = 'channelmap/olas/receive-olas-list';
export const REQUEST_OLAS_LIST = 'channelmap/olas/request-olas-list';
export const RESTART_STATE = 'channelmap/olas/restart_state';
export const SET_MASK = 'channelmap/olas/set-mask';
export const SET_ORDER = 'channelmap/olas/set-order';
export const SET_SELECTED_ROW = 'channelmap/olas/set-selected-row';
export const UPDATE_FIELD_FILTER = 'channelmap/olas/update-field-filter';
export const UPDATE_TABLE_COLUMN = 'channelmap/olas/set-selected-row';